import * as createjs from 'createjs-module';

export class CjStage extends createjs.Stage {
  constructor(canvas: HTMLCanvasElement | string | Object) {
    super(canvas);
    this.enableMouseOver();
  }
}